import Receipt from "@/components/main/receipt/component.vue";
import getSymbolFromCurrency from "currency-symbol-map";

import _ from "lodash";

export default {
  name: "",
  components: {
    Receipt,
  },
  props: [],
  data() {
    return {
      currencySymbol: "",
      years: [],
      selectedYear: {},
      items: [],
      subs: [],
      firstLoadDone: false,
      hasMore: false,
      page: 0,
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(this.items, "created", "desc");
    },
  },

  async created() {
    await this.GetItems();
  },
  mounted() {},

  methods: {
    GetSymbol(currency) {
      return getSymbolFromCurrency(currency);
    },

    async next() {
      await this.GetItems({
        afterId: this.items[this.items.length - 1].id,
      });
      this.page = this.page + 1;
    },

    async prev() {
      if (this.items.length === 0) return;

      await this.GetItems({ beforeId: this.items[0].id });
      this.page = this.page - 1;
    },

    async GetItems(params = {}) {
      this.firstLoadDone = false;
      let res = await this.$helpers.PostApi("get/invoices", params);

      this.items = res.data;

      if (params.beforeId && this.page == 1) {
        this.hasMore = true;
      } else {
        this.hasMore = res.has_more;
      }
      // this.years = [
      //   ...new Set(res.map(x => new Date(x.createdAt).getFullYear()))
      // ].map(x => {
      //   return { name: x, year: x };
      // });

      this.firstLoadDone = true;
    },
  },
};
